import Qs from 'qs'
import { API_ROOT } from '../util/config'
// import { getSessStore } from '../common/js/until'
const axios = require('axios').create({
  baseURL: API_ROOT,
  timeout: 10000,
  withCredentials: true, // 允许跨域 cookie
  headers: {
    // 'X-Requested-With': 'XMLHttpRequest', // 如何去response header中字段？
    // 'Content-Type': 'application/x-www-form-urlencoded'
  },
  transformRequest: [
    function (data) {
      // 对传入参数进行统一处理
      // 添加微信code
      // data && (data['code'] = getSessStore('code'))
      data = Qs.stringify(data)
      return data
    }],
  transformResponse: [
    function (data) { // 对返回的数据统一进行处理 返回到.then中
      let obj = {}
      try {
        obj = JSON.parse(data)
        if (obj.errno == -1) {
          location.href = obj.data
          return obj
        }
        return obj
      } catch (e) {
        return data
      }
    }]
})
// get
export const _get = (req) => {
  return axios({
    method: 'GET',
    url: `/${req.url}`
    // data: req.data
  })
}
// imgbuffer
export const _getimg = (req) => {
  return axios({
    method: 'GET',
    url: `/${req.url}`,
    responseType: 'arraybuffer'
  })
}
// put
export const _put = (req) => {
  return axios({
    method: 'PUT',
    url: `/${req.url}`,
    data: req.data
  })
}

// post
export const _post = (req, config) => {
  return axios({
    method: 'POST',
    url: `/${req.url}`,
    data: req.data,
    config: config
  })
}

// delete
export const _delete = (req) => {
  return axios({
    method: 'DELETE',
    url: `/${req.url}`,
    data: req.data
  })
}

// patch
export const _patch = (req) => {
  return axios({
    method: 'PATCH',
    url: `/${req.url}`,
    data: req.data
  })
}



// WEBPACK FOOTER //
// ./src/api/axios.config.js